module.exports = __webpack_public_path__ + "static/img/85028C_2_R_20190816_LC.1e4e5aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85028C_2_R_20190816_LC.png
// module id = lE4t
// module chunks = 0